import { render, staticRenderFns } from "./TaskListGroupItem.vue?vue&type=template&id=025a7a7c&scoped=true&"
import script from "./TaskListGroupItem.vue?vue&type=script&lang=js&"
export * from "./TaskListGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a7a7c",
  null
  
)

export default component.exports